module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety-large@2x.71a7eee2.png";